namespace Areas.CIB {
    "use strict";

    let accountCIBId: number;
    let accountId: number;
    let projectId: number;
    let isAdmin: boolean = false;
    let projectCCNumber: string;
    const baseUrl = "/Account/CIB";
    let budgetTotals: number;
    let fundTotals: number;
    let sub8: number;
    let signDate: Date;
    let noteTotals: number;
    let cibStatus: string;



    export function onCIBGridContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length) {
            e.component.selectRowsByIndexes(0);
        }

    }

    export function onEditFormContentReady(e: any) {
        var editForm: any = $("#AccountCIBEditForm").dxForm("instance");
        var editFormData = editForm.option("formData");

        budgetTotals = editFormData.GrandTotal;
        sub8 = editFormData.P8 + editFormData.P8i;
        accountCIBId = editFormData.AccountCIBId;


    }

    export function fundingGridOnContentReady(e: any) {
        fundTotals = e.component.getTotalSummaryValue("pwcAmountTotal");
        if (fundTotals != budgetTotals) {
            $("#wmessage").html("Funding Total is not equal to P0-P9 Totals");
        } else $("#wmessage").html("");
    }

    export function noteGridOnContentReady(e: any) {
        noteTotals = e.component.getTotalSummaryValue("notesAmountTotal");
        if (noteTotals != sub8) {
            $("#w2message").html("Note Total is not equal to P8 Amount");
        } else $("#w2message").html("");
    }


    export function onCIBGridSelectionChanged(e: any) {

        var rowData: any = e.selectedRowsData[0];

        var rowForm: any = $("#AccountCIBForm").dxForm("instance");
        rowForm.option("formData", rowData);

        budgetTotals = rowData.pwcTotal;
        sub8 = rowData.p8 + rowData.p8i;
        signDate = rowData.approvedCIBDate;
        cibStatus = rowData.accountCIBStatusLk
        isAdmin = rowForm.option("IsAdmin");

        const dataGrid = e.component as DevExpress.ui.dxDataGrid;
        accountCIBId = dataGrid.getSelectedRowKeys()[0];

        Areas.refreshGrid("AccountCIBNoteGrid");
        Areas.refreshGrid("AccountCIBFundingGrid")

        let dataId = dataGrid.getSelectedRowKeys()[0];
        Areas.Attachment.updateAttachmentControls(dataId, "AccountCIB");

        if (signDate != null) {
            if (!isAdmin) {
                disableGrids();
            }
        }

        if ((signDate != null) && (cibStatus == "Draft")) {
            $("#w3message").html("Approved CIB may not have Draft status");
        } else $("#w3message").html("");

    }



    export function getCIBId() {
        return accountCIBId;
    }

    export function addCIB() {
        const form = $("#AccountCIBForm").dxForm("instance");
        accountId = form.option("AccountId") as number;
        projectCCNumber = form.option("ProjectCCNumber") as string;
        accountCIBId = 0;

        $.get(`${baseUrl}/AddCIB/${accountId}/${projectCCNumber}`,
            (data) => {
                form.option("formData", data);
                disableGrids();

            });

        Areas.reloadPage();

    }

    export function editLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountCIBId; },
            "<a href= '/Account/CIB/Edit/{placeholder}'>Edit</a>");
    }

    export function goToViewCIB() {

        const form = $("#AccountCIBEditForm").dxForm("instance");
        accountId = form.option("AccountId") as number;
        const newData: any = form.option("formData");


        //Check for changes
        //if (newData != null) {
        //    updateRecord(newData)
        //}

        let url = "/Account/CIB/View/" + accountId;
        location.href = url;
        //window.open(url);
    }

    export function goToEditCIB() {
        const cibGrid = $("#AccountCIBGrid").dxDataGrid("instance");
        const selectedRows: any = cibGrid.getSelectedRowsData();
        if (selectedRows[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            accountCIBId = selectedRows[0].accountCIBId;
            budgetTotals = selectedRows[0].pwcTotal;
            let url = "/Account/CIB/Edit/" + accountCIBId;
            location.href = url;
            //window.open(url);
        }

    }

    function disableGrids() {
        const fundGrid = $("#AccountCIBFundingGrid").dxDataGrid("instance");
        const noteGrid = $("#AccountCIBNoteGrid").dxDataGrid("instance");
        //const budgetGrid = $("#AccountCIBBudgetGrid").dxDataGrid("instance");

        fundGrid.option("disabled", true);
        noteGrid.option("disabled", true);
        //budgetGrid.option("disabled", true);
    }

    function enableGrids() {
        const fundGrid = $("#AccountCIBFundingGrid").dxDataGrid("instance");
        const noteGrid = $("#AccountCIBNoteGrid").dxDataGrid("instance");
        //const budgetGrid = $("#AccountCIBBudgetGrid").dxDataGrid("instance");

        fundGrid.option("disabled", false);
        noteGrid.option("disabled", false);
        //budgetGrid.option("disabled", false);


    }

    export function updateCIB() {
        const form = $("#AccountCIBEditForm").dxForm("instance");
        const newData: any = form.option("formData");


        if (signDate != null) {
            if (isAdmin) {
                const verifyMod = window.confirm("Are you sure you would like to modify CIB Data that has been Signed?");

                if (!verifyMod) {
                    return;
                }
            }
            else {
                window.alert("You are NOT allowed to modify CIB Data that has been SIGNED!");

                return;
            }
        }


        if (newData.accountCIBId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }


    export function deleteCIB() {
        const cibGrid = $("#AccountCIBGrid").dxDataGrid("instance");
        const selectedRows: any = cibGrid.getSelectedRowsData();
        if (selectedRows[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {

            if (selectedRows[0].approvedCIBDate != null) {
                if (isAdmin) {
                    const verifyMod = window.confirm("Are you sure you would like to delete CIB Data that has been Signed?");

                    if (!verifyMod) {
                        return;
                    }
                }
                else {
                    window.alert("You are NOT allowed to modify CIB Data that has been SIGNED!");

                    return;
                }
            }

            const verifyMod = window.confirm("Are you sure you would like to delete this CIB ?");

            if (!verifyMod) {
                return;
            }

            selectedRows[0].isActive = false;

            if (selectedRows[0].accountCIBId != 0) {
                accountCIBId = selectedRows[0].accountCIBId;
                const url = `${baseUrl}/CIBPut/${accountCIBId}`;
                const method = "PUT";

                sendRequest(url,
                    JSON.stringify(selectedRows[0]),
                    method,
                    (data) => {
                        Areas.reloadPage();
                    });
            }
        }
    }

    function saveRecord(newData: any) {
        const url = `${baseUrl}/CIBPost`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
                enableGrids();
            }
        );
    }

    function updateRecord(newData: any) {

        let accountCIBId = newData.AccountCIBId;      ///AccountCIBId or accountCIBId

        const url = `${baseUrl}/CIBPut/${accountCIBId}`;
        const method = "PUT";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    export function onInitNewRowCIBDetail(e: any) {
        e.data.accountCIBId = accountCIBId;
        var a = 1;
    }

    export function copyCIB() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");
        accountId = form.option("AccountId") as number;
        accountCIBId = formData.accountCIBId;


        if (accountCIBId > 0) {

            const url = `/Account/CIB/CopyAccountCIB/${accountId}/${accountCIBId}`;
            sendRequest(url, "", "POST");
        }

    }

    export function selectPreparedBy() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogClosing("Preparer"));
    }

    export function selectApprovedBy() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogClosing("Campus"));
    }

    export function selectApprovedByAVP() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogClosing("AVP"));
    }


    function dialogClosing(buttonId: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#AccountCIBEditForm").dxForm("instance");
            const formData: any = form.option("formData");

            if (buttonId === "Preparer") {

                formData.PreparedByContactId = data.contactId;
                formData.PreparedByName = data.displayName;

            } else if (buttonId === "Campus") {

                formData.ApprovedByCampusContactId = data.contactId;
                formData.ApprovedByName = data.displayName;

            } else if (buttonId === "AVP") {

                formData.ApprovedByAVPContactId = data.contactId;
                formData.ApprovedByAVPName = data.displayName;

            }

            form.option("formData", formData);

        }
    }

    // select account

    function dialogProjectClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.AccountId = data.accountId;
        formData.AccountName = data.accountName;
        formData.ProjectCCNumber = data.projectCCNumber;

        form.option("formData", formData);
    }


    export function selectAccount() {
        const form: any = $("#AccountCIBeditForm").dxForm("instance");
        projectId = form.option("ProjectId");

        const parameters = { projectId: projectId };

        const projectLookupDialog =
            new Areas.Dialogs.Project.ProjectLookupDialog(dialogProjectClosing, parameters);
    }

    //select CAAN (building)

    function dialogCaanClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.CaanLk = data.caanLk;
        formData.BuildingName = data.buildingName;

        form.option("formData", formData);
    }


    export function selectBuilding() {

        const caanLookupDialog =
            new Areas.Dialogs.CaanDialog(dialogCaanClosing);
    }

    export function runCIB() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;

        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIB/${accountCIBId}`;
            window.open(url);
        }
    }

    export function runCIBDetail() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;

        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIBDetail/${accountCIBId}`;
            window.open(url);
        }
    }

    export function runCIBAnalytical() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;

        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIBAnalytical/${accountCIBId}`;
            window.open(url);
        }
    }

    export function runCIBBudget() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;
        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIBBudget/${accountCIBId}`;
            window.open(url);
        }
    }

    export function runCIBAnalyticalDetail() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;

        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIBAnalyticalDetail/${accountCIBId}`;
            window.open(url);
        }
    }

    export function runCIBBudgetDetail() {
        const form = $("#AccountCIBForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.accountCIBId;
        if (accountCIBId > 0) {
            const url = `/Account/CIB/GetCIBBudgetDetail/${accountCIBId}`;
            window.open(url);
        }
    }

    export function clearBuildingProperties(e: any) {
        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData = form.option("formData");

        formData.CaanLk = null;
        formData.BuildingName = null;
        form.option("formData", formData);
    }

    export function clearPreparedByProperties(e: any) {
        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData = form.option("formData");

        formData.PreparedByContactId = null;
        formData.PreparedByName = null;
        form.option("formData", formData);
    }

    export function clearApprovedByProperties(e: any) {
        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData = form.option("formData");

        formData.ApprovedByCampusContactId = null;
        formData.ApprovedByName = null;
        form.option("formData", formData);
    }

    export function clearAVPByProperties(e: any) {
        const form: any = $("#AccountCIBEditForm").dxForm("instance");
        const formData = form.option("formData");

        formData.ApprovedByAVPContactId = null;
        formData.ApprovedByAVPName = null;
        form.option("formData", formData);

    }

    export function editAccountCIBCost() {
        const form = $("#AccountCIBEditForm").dxForm("instance");
        const formData: any = form.option("formData");

        accountCIBId = formData.AccountCIBId;

        if (accountCIBId > 0) {
            const parameters = { accountCIBId: accountCIBId };
            const accountCIBCostDialog = new Areas.Dialogs.EditAccountCIBCost.EditAccountCIBCostDialog(dialogEditAccountCIBCostClosing, parameters);
        }
    }

    function dialogEditAccountCIBCostClosing(dialogResult: DialogResult) {

        if (dialogResult === DialogResult.Cancel) return;

        Areas.reloadPage();
    }
}
